export default "__VITE_ASSET__oOm06Ij3__"